import { useQuery } from "@apollo/client/react";
import type { ClientInvoiceUploadUnitModel } from "../../../models/ClientInvoiceUploadUnitModel";
import type { InvoiceUploadUnitStatus } from "../../../models/InvoiceUploadUnitStatus";
import GET_ALL_UPLOAD_UNITS from "../../queries/documentHandler/getAllUploadUnits";

type ClientUploadUnitResponseType = {
  clientInvoiceUploadUnits: {
    totalCount: number;
    items: Array<ClientInvoiceUploadUnitModel>;
  };
};

export const useAllUploadUnits = (
  missingClientIdentifier?: boolean,
  uploadUnitStatuses?: Array<InvoiceUploadUnitStatus>,
  maxUnitsPerClient?: number,
  clientIdentifier?: string,
  sortDirection?: "ASC" | "DESC",
  skip?: number,
  take?: number,
) => {
  const { data, error, loading, refetch } =
    useQuery<ClientUploadUnitResponseType>(GET_ALL_UPLOAD_UNITS, {
      variables: {
        missingClientIdentifier: missingClientIdentifier,
        uploadUnitStatuses: uploadUnitStatuses,
        maxUnitsPerClient: maxUnitsPerClient,
        clientIdentifier: clientIdentifier,
        sortDirection: sortDirection,
        skip: skip,
        take: take,
      },
      errorPolicy: "all",
    });
  return {
    clientUploadUnits: data?.clientInvoiceUploadUnits,
    error,
    loading,
    refetch,
  };
};
